import { useLayoutEffect, useMemo } from 'react'

import { createShouldDeferFilterMenuEscapeClose, handleFilterMenuEscapeKeydown } from './filter_menu_escape'

/**
 * Capture-phase Escape handler for filter menus. Runs from FilterMenuContent (layout effect)
 * so it registers before CUI FilterMenu's document listener (useEffect).
 */
export const useFilterMenuEscapeKeydown = ({
  isOpen,
  onClosePanel,
  getContainerElement,
  getPortalRoots,
  getMenuContentElement,
}) => {
  const shouldDeferFilterMenuEscapeClose = useMemo(
    () => createShouldDeferFilterMenuEscapeClose({ getPortalRoots, getMenuContentElement }),
    [getMenuContentElement, getPortalRoots],
  )

  useLayoutEffect(() => {
    if (!isOpen) return undefined

    const onKeyDown = (event) => {
      handleFilterMenuEscapeKeydown(event, {
        onClosePanel,
        getContainerElement,
        getPortalRoots,
        getMenuContentElement,
      })
    }

    document.addEventListener('keydown', onKeyDown, true)

    return () => document.removeEventListener('keydown', onKeyDown, true)
  }, [
    getContainerElement,
    getMenuContentElement,
    getPortalRoots,
    isOpen,
    onClosePanel,
  ])

  return shouldDeferFilterMenuEscapeClose
}
